import JSRuntime from 'common/utils/JSRuntime';
import createAxiosInstance from './CreateAxiosInstance';

/**
 * 以域名为baseUrl最基础的实例，以域名为基础区分实例
 */
const httpOauth2 = createAxiosInstance({ baseURL: JSRuntime.oauth2Site });
const httpAccountOauth2 = createAxiosInstance({ baseURL: JSRuntime.accountOauth2Site });
const http = createAxiosInstance({ baseURL: JSRuntime.apiSite });

export { httpOauth2, httpAccountOauth2, http };
